import CrmDashboardStore from "./Dashboard/CrmDashboard.Store";
import AccountsListStore from "./Accounts/AccountsList/AccountsList.Store";
import AccountDashboardStore from "./Accounts/AccountDashboard/AccountDashboard.Store";
import AccountFormStore from "./Accounts/AccountsList/dialogs/AccountForm/AccountForm.Store";
import OpportunitiesListStore from "./Opportunities/OpportunitiesList.Store";
import OpportunityDetailStore from "./Opportunities/dialogs/OpportunityDetail/OpportunityDetail.Store";
import OpportunityFormStore from "./Opportunities/dialogs/OpportunityForm/OpportunityForm.Store";
import ContactsListStore from "./Contacts/ContactsList.Store";
import ContactDetailStore from "./Contacts/dialogs/ContactDetail/ContactDetail.Store";
import ContactFormStore from "./Contacts/dialogs/ContactForm/ContactForm.Store";
import { BidsListStore } from "./Bids/BidsList.Store";
import { BidDetailStore } from "./Bids/dialogs/BidDetail/BidDetail.Store";
import { BidFormStore } from "./Bids/dialogs/BidForm/BidForm.Store";
import ProjectsListStore from "./Projects/ProjectsList.Store";
import ProjectDetailStore from "./Projects/dialogs/ProjectDetail/ProjectDetail.Store";
import ProjectFormStore from "./Projects/dialogs/ProjectForm/ProjectForm.Store";
import ProductionOrdersListStore from "./ProductionOrders/ProductionOrdersList.Store";
import ProductionOrderFormStore from "./ProductionOrders/dialogs/ProductionOrderForm/ProductionOrderForm.Store";
import JobPanelManagementStore from "./JobPanelManagement/JobPanelManagement.Store";
import PanelDesignCenterStore from "./PanelDesignCenter/PanelDesignCenter.Store";
import ProjectDetailsStore from "./Projects/ProjectDetails/ProjectDetails.Store";

const crmStoreList = [
  { name: "crmDashboardStore", store: CrmDashboardStore },
  { name: "accountsListStore", store: AccountsListStore },
  { name: "accountDashboardStore", store: AccountDashboardStore },
  { name: "accountFormStore", store: AccountFormStore },
  { name: "opportunitiesListStore", store: OpportunitiesListStore },
  { name: "opportunityDetailStore", store: OpportunityDetailStore },
  { name: "opportunityFormStore", store: OpportunityFormStore },
  { name: "contactsListStore", store: ContactsListStore },
  { name: "contactDetailStore", store: ContactDetailStore },
  { name: "contactFormStore", store: ContactFormStore },
  { name: "bidsListStore", store: BidsListStore },
  { name: "bidDetailStore", store: BidDetailStore },
  { name: "bidFormStore", store: BidFormStore },
  { name: "projectsListStore", store: ProjectsListStore },
  { name: "projectDetailStore", store: ProjectDetailStore },
  { name: "projectDetailsStore", store: ProjectDetailsStore },
  { name: "projectFormStore", store: ProjectFormStore },
  { name: "productionOrdersListStore", store: ProductionOrdersListStore },
  { name: "productionOrderFormStore", store: ProductionOrderFormStore },
  { name: "jobPanelManagementStore", store: JobPanelManagementStore },
  { name: "panelDesignCenterStore", store: PanelDesignCenterStore },
];

export default crmStoreList;
